

import { computed, defineComponent, onMounted, ref, watch } from 'vue';
import { useStore } from 'vuex'
// import Error from './paginas/app/Error.vue';
// import Access from './paginas/app/Access.vue';
import Login from './infrastructure/paginas/login/Login.vue'
import { CookieService } from '@ilinium/shared/src/common/infrastructure/servicios'
import { useRoute, useRouter } from 'vue-router'
import Environment from '@ilinium/shared/src/common/domain/constantes/environment'
import { defineAsyncComponent } from 'vue'
import TemplateTypeConst from '@ilinium/shared/src/common/domain/constantes/TemplateTypeConst'
import UbmChat from '@ilinium/shared/src/entidades/builder/chat/infrastructure/UbmChat.vue'
import { autoAuthRequest } from '@ilinium/shared/src/entidades/builderMaster/auth/domain/autoAuthRequest'
import { Actions } from '@ilinium/shared/src/common/infrastructure/almacen/enums/StoreEnums';
import Cargando from '@ilinium/shared/src/common/infrastructure/componentes/base/common/cargando/Cargando.vue'
import { container } from '../src/infrastructure/container'
import HelperLogin from '@ilinium/shared/src/entidades/builderMaster/auth/infrastructure/component/HelperLogin';
import EventBus from '@ilinium/shared/src/common/infrastructure/event-bus';
import EventConst from '@ilinium/shared/src/common/domain/constantes/EventConst';
import { AppLayoutConfig } from '../../shared/src/entidades/builder/template/infrastructure/prime/AppLayoutConfig'
import BlockViewer from './infrastructure/templates/prime/apollo/components/BlockViewer.vue';
import { app } from './main';

export default defineComponent({
    name: 'app_wrapper',
    components: {
        Login,
        UbmChat,
        Cargando
    },
    props: {
        
    },
    setup() {
        const PrestigeComp = defineAsyncComponent(() =>
            import('./infrastructure/templates/prime/prestige/App.vue'));

        const PrestigeISComp = defineAsyncComponent(() =>
            import('./infrastructure/templates/prime/prestige_intrasoft/AppPrestige.vue'));

        const PrestigeIntrasoftComp = defineAsyncComponent(() =>
            import('./infrastructure/templates/prime/prestige_intrasoft/AppPrestige.vue'));

        const UltimaComp = defineAsyncComponent(() =>
            import('./infrastructure/templates/prime/ultima/AppUltima.vue'));

        const ApolloComp = defineAsyncComponent(() =>
            import('./infrastructure/templates/prime/apollo/AppApollo.vue'));

        const store = useStore()
        const router = useRouter()
        let isLoading = ref<boolean>(false);
        const cargando = ref()


        if (!store.getters.isUserAuthenticated) {
            var value = window.location.pathname.length > 1 ? window.location.pathname.substr(1) : 'login';
            var query = window.location.search ?? '';
            const searchParams = new URLSearchParams(query);
            if (!value.includes('login') && window.location.href.includes('/rfps/?query=')) {
                CookieService.setCookie(CookieService.COOKIE_REDIRECT_URL, ('/' + value + query), 60 * 5); // 5 minutos
            } 
            else if (searchParams.get('broker') && searchParams.get('session') && searchParams.get('user') && searchParams.get('profileId')  
                        && searchParams.get('applicationId') && searchParams.get('applicationVersion')) {
                const broker = searchParams.get('broker');
                const session = searchParams.get('session');
                const applicationId = searchParams.get('applicationId');
                const applicationVersion = searchParams.get('applicationVersion');
                const profileId = searchParams.get('profileId');

                if (broker && session && applicationId && profileId && applicationVersion) {
                    externalLogin(broker, session, +profileId, +applicationId, +applicationVersion);
                }
            }
            else {
                CookieService.destroy(CookieService.COOKIE_REDIRECT_URL);
            }
            router.push({ name: 'login' });


            const route = useRoute()
            //console.log(route.query)
        }
        else {
            //this.addTab();
            //initializeChat();
        }

        function externalLogin(brokerId: string, sessionId: string, profileId: number, applicationId: number, applicationVersion: number) {
            const request = ref<autoAuthRequest>({
                    brokerId: brokerId,
                    sessionId: sessionId,
                    profileId: profileId,
                    applicationId: applicationId,
                    applicationVersion: applicationVersion,
                    external: true,
                });

                isLoading.value = true;
                //cargando.value.mostrar();
                store
                    .dispatch(Actions.AUTOAUTH, [request, container])
                    .then(() => {
                        //visibleRight.value = false;
                        //store.dispatch(Actions.CHANGEPROFILE, profileIdentifier)
                        HelperLogin.getApplicationMenus(true, router, Environment.APPID,Environment.APPVERSION, container, '');
                    })
                    .finally(() => {
                        isLoading.value = false;
                        (cargando.value).ocultar();
                        
                    });
        }

        const selectedTemplate = computed(() => {
            var appLayoutCfg = store.getters.getAppLayoutConfig as AppLayoutConfig;

            if (appLayoutCfg.template != undefined) {
                switch (appLayoutCfg.template) {
                    case TemplateTypeConst.PRIME_PRESTIGE:
                        //require('./infrastructure/templates/prime/prestige/App.scss');
                        import('./infrastructure/templates/prime/prestige/BlockViewer.vue').then((BlockViewer)=>{
                            //require('./infrastructure/templates/prime/prestige/assets/styles.scss');
                            /*
                            require('primevue/resources/primevue.min.css');
                            require('primeflex/primeflex.css');
                            require('primeicons/primeicons.css');
                            require('prismjs/themes/prism-coy.css');
                            */
                            app.component('BlockViewer', BlockViewer);
                        
                        });
                        return PrestigeComp;                    
                    case TemplateTypeConst.PRIME_PRESTIGEIS:
                        //require('./infrastructure/templates/prime/prestige/App.scss');
                        return PrestigeISComp;

                    case TemplateTypeConst.PRIME_PRESTIGE_INTRASOFT:
                        //require('./infrastructure/templates/prime/prestige/App.scss');
                        return PrestigeIntrasoftComp;

                    case TemplateTypeConst.PRIME_ULTIMA:
                        import('./infrastructure/templates/prime/ultima/components/BlockViewer.vue').then((BlockViewer)=>{
                            require('./infrastructure/templates/prime/ultima/assets/styles.scss');
                            app.component('BlockViewer', BlockViewer);
                        });
                        return UltimaComp;
                    case TemplateTypeConst.PRIME_APOLLO:
                        require('./infrastructure/templates/prime/apollo/assets/styles.scss');
                        app.component('BlockViewer', BlockViewer);
                        return ApolloComp;
                    default:
                        return PrestigeIntrasoftComp;
                }
            }

        })



        onMounted(() => {
            EventBus.on(EventConst.LOADING, (show) => {
                if (show) {
                    if (cargando.value) {
                        cargando.value.mostrar()
                    }
                } else {
                    if (cargando.value) {
                        cargando.value.ocultar()
                    }
                }
            })
        })


        return {
            selectedTemplate,
            cargando
        };
    },
});
